import { DistUrl } from "rev-shared/bootstrap/BootstrapContext";

export enum ResourceType {
	Video = 'video',
	Webcast = 'webcast'
}

export const C2PA_RESOURCE_CONFIG = {
	wasmSrc: `${DistUrl}c2pa-assets/c2pa_bg.wasm`,
}
